var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M56,0C25.1,0,0,25.1,0,56s25.1,56,56,56c30.9,0,56-25.1,56-56S86.9,0,56,0z M37.1,83.3V28.7L83.3,56L37.1,83.3z","fill":"currentColor"}));
}

Play.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 112 112","style":{"enableBackground":"new 0 0 112 112"},"xmlSpace":"preserve"};

module.exports = Play;

Play.default = Play;
